/* KAAFEY storefront — scroll story (photo / stylised 3D / real .glb when supplied), buy flow, funnel analytics.
   Volgorde: echt .glb (sectie-instelling) → gestileerd three.js-model → fotoverhaal (low-power / geen WebGL). */
(() => {
  const STEPS = 6;
  const clamp = (n, lo = 0, hi = 1) => Math.max(lo, Math.min(hi, n));
  const STEP_NAMES = ['portable', 'fill', 'load', 'heat', 'brew', 'enjoy'];
  const fired = new Set();
  // Funnel events. Consumed by: window.dataLayer (GA4/GTM), Shopify custom pixels (Shopify.analytics.publish) and any listener on document ('kaafey:event').
  function track(name, data = {}, once = true) {
    if (once) { if (fired.has(name)) return; fired.add(name); }
    const payload = Object.assign({ event: name, brand: 'kaafey', page: location.pathname, ts: Date.now() }, data);
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('kaafey:event', { detail: payload })); } catch (e) {}
  }
  window.kaafeyTrack = track;

  function loadModel(stage, journey) {
    const src = stage.dataset.model;
    if (!src || !window.Shopify || typeof Shopify.loadFeatures !== 'function') return null;
    const holder = stage.querySelector('.shot-model');
    const state = { el: null };
    Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: err => {
      if (err) return;
      const mv = document.createElement('model-viewer');
      mv.setAttribute('src', src);
      mv.setAttribute('camera-orbit', '0deg 80deg 105%');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('shadow-intensity', '1');
      mv.setAttribute('exposure', '1.05');
      mv.setAttribute('alt', holder.getAttribute('aria-label') || 'KAAFEY');
      mv.addEventListener('load', () => journey.classList.add('has-model'));
      holder.appendChild(mv);
      state.el = mv;
    } }]);
    return state;
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const journey = root.querySelector('.journey');
    const stage = root.querySelector('.stage');
    const steps = [...root.querySelectorAll('.step-copy')];
    const navs = [...root.querySelectorAll('[data-goto]')];
    const layers = [...root.querySelectorAll('.shot-layer')];
    const counters = root.querySelectorAll('[data-step-counter]');
    const labels = root.querySelectorAll('[data-step-label]');
    const bar = root.querySelector('.journey-progress i');
    const heatEl = root.querySelector('[data-heat-target]');
    const heatVal = root.querySelector('[data-heat-value]');
    const shop = root.querySelector('#shop');
    const sticky = root.querySelector('.sticky-buy');
    let active = -1, progress = 0, ticking = false, inView = false, model = null, three = null;

    function setStep(n) {
      if (n === active) return;
      active = n;
      journey.dataset.step = n;
      steps.forEach((a, i) => { a.classList.toggle('is-active', i === n); a.setAttribute('aria-hidden', i === n ? 'false' : 'true'); });
      navs.forEach((b, i) => { b.classList.toggle('is-active', i === n); if (i === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      layers.forEach(l => l.classList.toggle('is-on', Number(l.dataset.for) === n));
      const num = String(n + 1).padStart(2, '0');
      counters.forEach(c => { c.textContent = num; });
      labels.forEach(l => { l.textContent = navs[n] ? navs[n].dataset.label : ''; });
      if (n >= 0 && inView) track(STEP_NAMES[n] + '_seen', { step: n + 1 });
    }
    function frame() {
      ticking = false;
      if (journey) {
        const r = journey.getBoundingClientRect();
        inView = r.top < innerHeight && r.bottom > 0;
        if (inView) { track('journey_started'); if (active >= 0) track(STEP_NAMES[active] + '_seen', { step: active + 1 }); }
        progress = clamp(-r.top / Math.max(1, journey.offsetHeight - innerHeight));
        const phase = progress * STEPS;
        setStep(Math.min(STEPS - 1, Math.floor(phase)));
        const heat = clamp(phase - 3);
        journey.style.setProperty('--heat', heat.toFixed(3));
        if (heatEl && heatVal) { const t = parseFloat(heatEl.dataset.heatTarget) || 0; heatVal.textContent = Math.round(20 + heat * (t - 20)) + '°'; }
        if (bar) bar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
        if (model && model.el && inView && !reduced) model.el.cameraOrbit = (-20 + progress * 380).toFixed(1) + 'deg 78deg 105%';
        if (three) { const st = Math.min(STEPS - 1, Math.floor(phase)); three.setProgress(progress, st, clamp(phase - st)); three.setVisible(inView); }
      }
      if (sticky && shop) {
        const s = shop.getBoundingClientRect();
        const show = scrollY > innerHeight * .9 && !(s.top < innerHeight && s.bottom > 0) && !(inView && innerWidth > 760);
        sticky.classList.toggle('is-visible', show);
        if (show) track('sticky_atc_shown');
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(b => { b.tabIndex = show ? 0 : -1; });
      }
    }
    const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });

    navs.forEach(b => b.addEventListener('click', () => {
      const n = Number(b.dataset.goto);
      const top = journey.getBoundingClientRect().top + scrollY;
      scrollTo({ top: top + (journey.offsetHeight - innerHeight) * ((n + .45) / STEPS), behavior: reduced ? 'auto' : 'smooth' });
    }));

    // Journey media. Voorkeur: echt .glb (data-model) -> gestileerd three.js-model (kaafey-3d.js) -> fotoverhaal.
    const lowPower = (navigator.connection && navigator.connection.saveData) || (navigator.deviceMemory || 8) <= 2 || reduced;
    const start3D = () => {
      if (!stage || !stage.dataset['3d'] || lowPower) return;
      const canvas = stage.querySelector('.shot-3d');
      const probe = document.createElement('canvas');
      if (!canvas || !(probe.getContext('webgl2') || probe.getContext('webgl'))) return;
      import(new URL(stage.dataset['3d'], location.href).href).then(mod => {
        three = mod.createKaafey3D(canvas, { maxDpr: (navigator.hardwareConcurrency || 8) <= 4 ? 1 : 1.6 });
        if (!three) return;
        three.setProgress(progress, Math.max(0, active), 0);
        three.setVisible(inView);
        journey.classList.add('has-3d');
        track('model_3d_loaded', { kind: 'stylised' });
      }).catch(e => { console.warn('KAAFEY 3D unavailable', e); });
    };
    if (journey && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        if (!entries.some(e => e.isIntersecting)) return;
        journey.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
        if (stage && stage.dataset.model) { model = loadModel(stage, journey); track('model_3d_loaded', { kind: 'glb' }); } else start3D();
        io.disconnect();
      }, { rootMargin: '900px 0px' });
      io.observe(journey);
    }

    // Section-level funnel events
    if ('IntersectionObserver' in window) {
      const watch = (sel, name, extra) => { const el = root.querySelector(sel); if (!el) return; const o = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { track(name, extra || {}); o.disconnect(); } }, { threshold: 0.35 }); o.observe(el); };
      watch('.hero', 'hero_seen');
      watch('#shop', 'price_seen', { price: (root.querySelector('.price-row strong') || {}).textContent });
      watch('#overal', 'anywhere_seen', { step: 7 });
      watch('#reviews', 'reviews_seen');
      watch('#vergelijk', 'comparison_seen');
      watch('#specs', 'specs_seen');
      watch('#faq', 'faq_seen');
      watch('.closing', 'final_cta_seen');
    }
    root.querySelectorAll('.hero-cta a, .closing .button, .uses .text-link, .step-copy .text-link').forEach(a => a.addEventListener('click', () => track('cta_to_product_click', { from: a.closest('section') ? a.closest('section').className.split(' ')[0] : 'unknown' }, false)));
    root.querySelectorAll('.faq-list details').forEach(d => d.addEventListener('toggle', () => { if (d.open) track('faq_open', { question: (d.querySelector('summary') || {}).textContent }, false); }));
    root.querySelectorAll('.gallery-track').forEach(t => { let seen = false; t.addEventListener('scroll', () => { if (!seen) { seen = true; track('gallery_swipe'); } }, { passive: true }); });

    // Gallery dots + arrows (built from the slides that actually rendered)
    const galleryTrack = root.querySelector('.gallery-track');
    const dotsWrap = root.querySelector('[data-dots]');
    if (galleryTrack && dotsWrap) {
      const slides = galleryTrack.querySelectorAll('.gallery-slide');
      const goTo = i => { const n = (i + slides.length) % slides.length; galleryTrack.scrollTo({ left: galleryTrack.clientWidth * n, behavior: reduced ? 'auto' : 'smooth' }); track('gallery_arrow', { to: n + 1 }, false); };
      const current = () => Math.round(galleryTrack.scrollLeft / Math.max(1, galleryTrack.clientWidth));
      root.querySelectorAll('[data-gallery-prev]').forEach(b => b.addEventListener('click', () => goTo(current() - 1)));
      root.querySelectorAll('[data-gallery-next]').forEach(b => b.addEventListener('click', () => goTo(current() + 1)));
      if (slides.length > 1) {
        slides.forEach((_, i) => {
          const d = document.createElement('button');
          d.type = 'button'; d.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
          if (i === 0) d.classList.add('is-active');
          d.addEventListener('click', () => galleryTrack.scrollTo({ left: galleryTrack.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' }));
          dotsWrap.appendChild(d);
        });
        const dots = [...dotsWrap.children];
        galleryTrack.addEventListener('scroll', () => { const i = Math.round(galleryTrack.scrollLeft / Math.max(1, galleryTrack.clientWidth)); dots.forEach((d, j) => d.classList.toggle('is-active', i === j)); }, { passive: true });
      }
    }

    // Dialog + buy flow
    const dialog = root.querySelector('.coffee-dialog');
    if (dialog) {
      dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    }
    const status = root.querySelector('.buy-status');
    // Bundle-keuze (Alleen KAAFEY / KAAFEY + CUP): knopprijs meeschakelen
    const bundleInputs = [...root.querySelectorAll('input[name="kaafey-bundle"]')];
    const priceEls = root.querySelectorAll('[data-buy-price]');
    const selectedCup = () => { const c = bundleInputs.find(i => i.checked); return c && c.value === 'duo' ? Number(c.dataset.cupId) : 0; };
    const syncPrice = () => { const duo = !!selectedCup(); priceEls.forEach(el => { el.textContent = duo && el.dataset.duo ? el.dataset.duo : el.dataset.solo; }); };
    bundleInputs.forEach(i => i.addEventListener('change', () => { syncPrice(); track('bundle_select', { choice: i.value }, false); }));
    syncPrice();

    // Upsell-sheet (1x per sessie) als iemand alleen KAAFEY kiest
    const sheet = root.querySelector('[data-upsell]');
    const seenSheet = () => { try { return sessionStorage.getItem('kaafey_upsell_seen') === '1'; } catch (e) { return true; } };
    const markSheet = () => { try { sessionStorage.setItem('kaafey_upsell_seen', '1'); } catch (e) {} };
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    async function addAndGo(source, cupId, button) {
      const items = [{ id: Number(root.dataset.variant), quantity: 1 }];
      if (cupId) items.push({ id: cupId, quantity: 1 });
      if (cupId) track('addon_added', { addons: 1, via: source }, false);
      if (button) button.disabled = true;
      if (status) status.textContent = root.querySelector('[data-copy-loading]').textContent;
      try {
        const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error('cart');
        track('add_to_cart_success', { source, items: items.length, bundle: !!cupId }, false);
        track(root.dataset.after === 'cart' ? 'cart_redirect' : 'checkout_redirect', { source }, false);
        location.assign(base + (root.dataset.after === 'cart' ? 'cart' : 'checkout'));
      } catch (e) {
        track('add_to_cart_error', { source }, false);
        if (status) status.textContent = root.querySelector('[data-copy-error]').textContent;
        if (button) button.disabled = false;
      }
    }

    if (sheet) {
      const close = () => { if (sheet.open) sheet.close(); };
      sheet.addEventListener('click', e => { if (e.target === sheet) { close(); track('upsell_sheet_dismiss', {}, false); } });
      sheet.querySelector('[data-upsell-close]').addEventListener('click', () => { close(); track('upsell_sheet_dismiss', {}, false); });
      sheet.querySelector('[data-upsell-yes]').addEventListener('click', e => { track('upsell_sheet_accept', {}, false); addAndGo(sheet.dataset.source || 'upsell_sheet', Number(e.currentTarget.dataset.cupId), e.currentTarget); });
      sheet.querySelector('[data-upsell-no]').addEventListener('click', e => { track('upsell_sheet_decline', {}, false); addAndGo(sheet.dataset.source || 'upsell_sheet', 0, e.currentTarget); });
    }

    root.querySelectorAll('[data-buy]').forEach(button => button.addEventListener('click', () => {
      const source = button.classList.contains('sticky-btn') ? 'sticky' : 'product_card';
      track('add_to_cart_click', { source, available: root.dataset.available === 'true', bundle: !!selectedCup() }, false);
      if (root.dataset.available !== 'true' || !root.dataset.variant) { track('sold_out_dialog_shown', { source }, false); if (dialog) dialog.showModal(); return; }
      const cupId = selectedCup();
      if (!cupId && sheet && !seenSheet() && typeof sheet.showModal === 'function') {
        markSheet(); sheet.dataset.source = source; sheet.showModal(); track('upsell_sheet_shown', { source }, false); return;
      }
      addAndGo(source, cupId, button);
    }));

    frame();
  }

  const boot = () => document.querySelectorAll('.coffee-experience').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('.coffee-experience')));

  // Footer localization: submit on change
  document.addEventListener('change', e => { const f = e.target.closest && e.target.closest('form.localization'); if (f) f.submit(); });
})();

